export default "__VITE_ASSET__Dklz3a1j__"